module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_7.5c6a69c0.png";